import { render, staticRenderFns } from "./EasyMatrix.vue?vue&type=template&id=3b352e65"
import script from "./EasyMatrix.vue?vue&type=script&lang=js"
export * from "./EasyMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports